export type DayKey = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'

export const WEEKDAY_KEYS: DayKey[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
export const NON_BILLABLE_CATEGORIES = ['Admin', 'CPD', 'Sick leave', 'Annual leave'] as const
export type NonBillableCategory = (typeof NON_BILLABLE_CATEGORIES)[number]

export type ProjectOption = {
  id: string
  ref: string
  name: string
  client: string
  departments: string[]
}

export type TimesheetRow = {
  id: string
  billable: boolean
  projectId?: string
  department?: string
  category?: NonBillableCategory
  notes: string
  hours: Record<DayKey, string>
  templateId?: string
}

export type TimesheetAllocationTemplate = {
  id: string
  billable: boolean
  projectId?: string
  department?: string
  category?: NonBillableCategory
  startsFromWeek: string
}

export function emptyHours(): Record<DayKey, string> {
  return { mon: '', tue: '', wed: '', thu: '', fri: '', sat: '', sun: '' }
}

export function getRowTotal(row: TimesheetRow) {
  return WEEKDAY_KEYS.reduce((total, day) => total + parseHours(row.hours[day]), 0)
}

export function parseHours(value: string) {
  const amount = Number(value)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}
